var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1,10.5v-3c0-.496,.404-.9,.9-.9s.9,.404,.9,.9v3c0,.496-.404,.9-.9,.9s-.9-.404-.9-.9Zm-9.1,.9c.496,0,.9-.404,.9-.9v-3c0-.496-.404-.9-.9-.9s-.9,.404-.9,.9v3c0,.496,.404,.9,.9,.9Zm15,5.6h-6.922c-.471,0-.917,.207-1.221,.566l-.198,.234h-3.319l-.197-.233c-.304-.359-.751-.567-1.222-.567H2c-1.105,0-2,.895-2,2s.895,2,2,2H22c1.105,0,2-.895,2-2s-.895-2-2-2Zm0-9.5v7.61c-.323-.067-.656-.11-1-.11h-5.151c-.983,0-1.92,.359-2.646,1h-2.404c-.726-.641-1.663-1-2.646-1H3c-.344,0-.677,.043-1,.11V7.5c0-2.485,2.015-4.5,4.5-4.5h11c2.485,0,4.5,2.015,4.5,4.5Zm-12.5,0c0-1.381-1.119-2.5-2.5-2.5s-2.5,1.119-2.5,2.5v3c0,1.381,1.119,2.5,2.5,2.5s2.5-1.119,2.5-2.5v-3Zm3.8-1.7c0-.442-.358-.8-.8-.8-.258,0-.477,.13-.623,.32l-1.372,1.49c-.32,.353-.293,.899,.06,1.219h0c.329,.298,.813,.279,1.136-.003v4.173c0,.442,.358,.8,.8,.8s.8-.358,.8-.8V5.8Zm6.2,1.7c0-1.381-1.119-2.5-2.5-2.5s-2.5,1.119-2.5,2.5v3c0,1.381,1.119,2.5,2.5,2.5s2.5-1.119,2.5-2.5v-3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoints);
export default __webpack_public_path__ + "static/media/points.25723c179216fb4ebd8f1863f42a7c64.svg";
export { ForwardRef as ReactComponent };